(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trades-agency"] && !Shopify.designMode) return;
  try {
    

(() => {
 const work = document.getElementById('project-work');
 document.querySelectorAll('[data-work]').forEach(link => link.addEventListener('click', () => {
  if (work) {work.value = link.dataset.work; work.dispatchEvent(new Event('change', {bubbles:true}));}
 }));
 const sticky = document.querySelector('.mobile-cta');
 const enquiry = document.getElementById('enquiry');
 if (sticky && enquiry && 'IntersectionObserver' in window) {
  new IntersectionObserver(entries => sticky.classList.toggle('is-hidden', entries[0].isIntersecting), {threshold:0}).observe(enquiry);
 }
 const share = document.querySelector('[data-share]');
 if (share && navigator.share) share.addEventListener('click', async event => {
  event.preventDefault();
  try {await navigator.share({title:'TradeLink Homes',text:'Planning a home project? Take a look at TradeLink Homes.',url:'https://tradelinkhomes.co.uk'});} catch (error) {if (error.name !== 'AbortError') window.location.href = share.href;}
 });
})();


  } catch(e) { console.error(e); }
})();
})();
